import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=99d40856&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=js&"
export * from "./SortIcon.vue?vue&type=script&lang=js&"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=99d40856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d40856",
  null
  
)

export default component.exports